exports = module.exports = require("../../../../../node_modules/.0.26.4@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".m-b-5[data-v-d2722492]{margin-bottom:5px}.m-t-20[data-v-d2722492]{margin-top:20px}", "", {"version":3,"sources":["W:/Web/GitHub/vue-custom-input/src/js/app/number-input-demo/component/demo.vue"],"names":[],"mappings":"AACA,wBACE,iBAAmB,CACpB,AACD,yBACE,eAAiB,CAClB","file":"demo.vue","sourcesContent":["\n.m-b-5[data-v-d2722492] {\n  margin-bottom: 5px;\n}\n.m-t-20[data-v-d2722492] {\n  margin-top: 20px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/.0.26.4@css-loader?{"minimize":true,"sourceMap":true}!./~/.11.3.4@vue-loader/lib/style-compiler?{"id":"data-v-d2722492","scoped":true,"hasInlineConfig":false}!./~/.6.0.6@sass-loader/lib/loader.js?{"sourceMap":true}!./~/.11.3.4@vue-loader/lib/selector.js?type=styles&index=0!./src/js/app/number-input-demo/component/demo.vue
// module id = 5
// module chunks = 0